import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert } from 'src/domains/common/components/alert/alert';
import Loading from 'src/components/Loading/Loading';
import { useAppStateContext } from 'src/AppState/AppState';
import { AutoLogoutState } from 'src/components/ComplianceConfiguration/AutoLogout/AutoLogout.state';
import { AutoLogoutForm } from 'src/components/ComplianceConfiguration/AutoLogout/AutoLogoutForm';
import {
    AutoLogoutDescription,
    AutoLogoutWrapper,
} from 'src/components/ComplianceConfiguration/AutoLogout/AutoLogout.style';

export const AutoLogout = observer((): JSX.Element => {
    const appState = useAppStateContext();
    const [state] = useState(() => new AutoLogoutState(appState));

    useEffect(() => () => state.dispose(), [state]);

    if (state.isLoading) {
        return (
            <AutoLogoutWrapper data-test='compliance-configuration-auto-logout-loading'>
                <Loading active />
            </AutoLogoutWrapper>
        );
    }

    return (
        <AutoLogoutWrapper data-test='compliance-configuration-auto-logout'>
            <Alert
                icon='info'
                title='Auto logout'
                variant='default'
            >
                Configure the global inactivity timeout for authenticated customer sessions. The value is applied to
                both session expiration and active-session extension.
            </Alert>

            <AutoLogoutDescription>
                Enter the inactivity period in hours. The default value is 6 hours.
            </AutoLogoutDescription>

            {state.errorMessage === null || state.errorMessage === '' ? null : (
                <Alert
                    icon='info'
                    title={state.errorMessage}
                    variant='destructive'
                />
            )}

            <AutoLogoutForm state={state} />
        </AutoLogoutWrapper>
    );
});
